module.exports = __webpack_public_path__ + "img/labmem_icon_x.53e1c8e5.png";